import { FC, KeyboardEventHandler, MouseEventHandler } from 'react';

import { ButtonProps } from 'antd';

import CustomIcon, { SeturIcon } from '@components/utils/CustomIcon';

// eslint-disable-next-line react/display-name
export const renderNavButton =
  (
    ButtonComponent: FC<ButtonProps>,
    icon: SeturIcon,
    fontSize = 12,
    topSize?: number
    // eslint-disable-next-line react/display-name
  ) =>
  ({
    ariaLabel,
    disabled,
    onClick,
    onKeyUp,
    onMouseUp,
  }: {
    ariaLabel: string;
    disabled: boolean;
    onClick?: MouseEventHandler;
    onKeyUp?: KeyboardEventHandler;
    onMouseUp?: MouseEventHandler;
  }) => {
    return (
      <ButtonComponent
        aria-label={ariaLabel}
        disabled={disabled}
        onClick={onClick}
        onKeyUp={onKeyUp}
        onMouseUp={onMouseUp}
        style={{ top: topSize }}
        icon={
          <CustomIcon icon={icon} fontSize={fontSize} paletteColor='darkGray' />
        }
        type='link'
      />
    );
  };
